import React, { ComponentProps, useEffect } from "react";
import * as S from "./styles";
import { Outlet } from "react-router-dom";
import { Button } from "../../Atoms/Button";
import { useLayout } from "./useLayout";
import { useAccess } from "../../../hooks/useAccess";
import { MyModal } from "../../Atoms/MyModal";
import { Bar } from "../../Atoms/Bar";
import { NavLink } from "react-router-dom";
import { RecursosEnum } from "../../../enums/recusos";

interface LayoutTemplateProps extends ComponentProps<"div"> {
  children?: React.ReactNode;
}

export const LayoutTemplate = (props: LayoutTemplateProps) => {
  const {
    logout,
    menuOpen,
    setMenuOpen,
    token,
    modalIsOpen,
    navigate,
    isAdmin,
    setModalIsOpen,
    isCliente,
    isVistoriador,
    LINKS,
    destinoNovoAgendamento,
    usuario,
    setProximaRotaAgendamento,
  } = useLayout();
  const access = useAccess(usuario, isAdmin);

  return (
    <S.Container {...props}>
      <S.WrapperMainMenu>
        <S.MainMenu data-open={menuOpen}>
          <S.WrapperIconCloseMainMenu>
            <S.IconCloseMainMenu
              src="/assets/svgs/arrow-left.svg"
              alt="icone close menu"
              onClick={() => setMenuOpen(false)}
            />
          </S.WrapperIconCloseMainMenu>

          <S.WrapperButton>
            {token ? (
              <div>
                <button onClick={() => setModalIsOpen(true)}>Logout</button>
              </div>
            ) : (
              <div>
                <NavLink className={"navLink"} end to={"/agendamento/auth"}>
                  Login
                </NavLink>
              </div>
            )}

            {token && (
              <>
                <div>
                  <NavLink className={"navLink"} to={"/perfil"}>
                    Meu Perfil
                  </NavLink>
                </div>
                <div>
                  <NavLink end className={"navLink"} to={"/meus-agendamentos"}>
                    Agendamentos
                  </NavLink>
                </div>

                <div>
                  <NavLink
                    className={"navLink"}
                    end
                    to={destinoNovoAgendamento}
                  >
                    Novo Agendamento
                  </NavLink>
                </div>
                {!isCliente && (
                  <div>
                    <NavLink
                      className={"navLink"}
                      end
                      to={"/meus-agendamentos/atendimentos-loja"}
                    >
                      Atendimento Loja
                    </NavLink>
                  </div>
                )}

                {access.hasResource(RecursosEnum.MINHAS_VISTORIAS) && (
                  <div>
                    <NavLink className={"navLink"} end to={"/minhas-vistorias"}>
                      Minhas Vistorias
                    </NavLink>
                  </div>
                )}

                {!isCliente && (
                  <div>
                    <NavLink
                      className={"navLink"}
                      end
                      to={"/meus-agendamentos/deliverys"}
                    >
                      Deliverys
                    </NavLink>
                  </div>
                )}
                {access.hasAccess("CONFIGURACOES") && (
                  <div>
                    <NavLink className={"navLink"} end to={"/configuracoes"}>
                      Configurações
                    </NavLink>
                  </div>
                )}

                {access.hasResource(RecursosEnum.AGENDAMENTO_ITINERANTE) && (
                  <div>
                    <NavLink
                      className={"navLink"}
                      end
                      to={"/agendamento/buscar-cliente"}
                      onClick={() =>
                        setProximaRotaAgendamento("/agendamento/itinerantes")
                      }
                    >
                      Itinerante
                    </NavLink>
                  </div>
                )}

                {access.hasAccess(RecursosEnum.MAPA_BI) && (
                  <div>
                    <NavLink
                      className={"navLink"}
                      end
                      to={process.env.REACT_APP_BI_URL}
                    >
                      BI
                    </NavLink>
                  </div>
                )}

                {access.hasAccess(RecursosEnum.DENUNCIAS) && (
                  <div>
                    <NavLink className={"navLink"} end to={"/denuncias"}>
                      Denúncias de Abuso
                    </NavLink>
                  </div>
                )}

                {access.hasAccess(RecursosEnum.DOCUMENTOS) && (
                  <div>
                    <NavLink className={"navLink"} end to={"/documentos"}>
                      Documentos
                    </NavLink>
                  </div>
                )}
                {access.hasAccess(RecursosEnum.TREINAMENTOS) && (
                  <div>
                    <NavLink className={"navLink"} end to={"/treinamentos"}>
                      Treinamentos
                    </NavLink>
                  </div>
                )}
              </>
            )}
          </S.WrapperButton>
        </S.MainMenu>
      </S.WrapperMainMenu>

      <S.WrapperMain>
        <Bar>
          <S.WrapperIconsBar>
            <S.IconMenuHamburguer
              src="/assets/svgs/menuHamburguer.svg"
              alt="icone do menu hamburguer"
              onClick={() => setMenuOpen(true)}
            />
            <S.IconLogo
              src={`/assets/svgs/logo-${process.env.REACT_APP_PROJECT}.svg`}
              alt="logo empresa"
            />
            <S.IconHome
              src="/assets/svgs/icone-home.svg"
              alt="icone home"
              onClick={() =>
                window.open(LINKS[process.env.REACT_APP_PROJECT], "_self")
              }
            />
          </S.WrapperIconsBar>
        </Bar>
        <S.Wrapper>
          <S.Main>
            {props.children}
            <Outlet />
          </S.Main>
          {/* <S.IconMap src="/assets/svgs/paguexlogo.svg" alt="icone mapa" /> */}
        </S.Wrapper>
      </S.WrapperMain>
      <MyModal
        isOpen={modalIsOpen}
        onRequestClose={() => setModalIsOpen(false)}
      >
        <S.ModalContent>
          <S.ModalHeader>
            <p onClick={() => setModalIsOpen(false)}>X</p>
          </S.ModalHeader>

          <S.ModalTextContent>
            <p>
              Tem certeza que deseja fazer <strong>logout</strong>?
            </p>

            <div className="wrapperButtons">
              <Button data-variant-text onClick={() => setModalIsOpen(false)}>
                Cancelar
              </Button>
              <Button data-variant-dark onClick={logout}>
                Confirmar
              </Button>
            </div>
          </S.ModalTextContent>
        </S.ModalContent>
      </MyModal>
    </S.Container>
  );
};
